import { isGroupTableQuery } from "owa-group-utils";
import type { TableQuery } from "owa-mail-list-store";
import { isCopilotResultsTable, type TableQueryType } from "owa-mail-list-store";

export function shouldTableSupportFlag(tableQuery: TableQuery): boolean {
    // Support flagging in Search and Folder and CopilotResults view.
    return (!isGroupTableQuery(tableQuery) &&
        (tableQuery.type == 1 ||
            tableQuery.type == 0 ||
            isCopilotResultsTable(tableQuery)));
}
